import { Link } from 'react-router-dom';
import React,{ useContext } from 'react';
import classes from './MainNavigation.module.css';
import geotolkLogo from "../Geotolk/Introduction/geotolk-blue.svg";
import { useAuthInfo } from '@propelauth/react';


const MainNavigation = () => {
  const user = useAuthInfo().user;
  
  return (
    <header className={classes.header}>
        <div >
        <img
        alt="Geotolk"
        src={geotolkLogo}
        width="250px"
        align="center"
        id="logo"
        className="headerLogo"/>  <Link to='/geotolk/projects'><p>Projects</p></Link></div>
        <ul>
          {user.isLoggedIn && <li>
            <a style={{ whiteSpace: 'nowrap', fontWeight: 'normal' }}>Logget inn som {user.firstName} {user.lastName}</a>
          </li>}
        </ul>
    </header>
  );
};






export default MainNavigation;
